import * as types from "./types";
import createReducersFromTypes from "store/createReducersFromTypes";

export default createReducersFromTypes(types);
